import * as React from 'react'
import {render} from 'react-dom'
import {VaalikoneCandidateApp} from './app'
import {Stores} from './stores'
import {confMobx} from './stores/mobxConf'
;(async () => {
  confMobx()
  const stores = new Stores()
  await stores.authStore.init()
  render(<VaalikoneCandidateApp stores={stores} />, document.getElementById('root'))
})()
